'use client';
import Image from 'next/image';
import Link from 'next/link';

// const partners = [
//   {
//     alt: "Financial-service-review",
//     src: "/images/financial-service-review.webp",
//     link: "https://www.financialservicesreview.com/",
//   },
//   {
//     alt: "aiml",
//     src: "/images/aiml.webp",
//     link: "https://aiml.events/",
//   },
//   {
//     alt: 'startupnews-logo',
//     src: '/images/startupnews-logo.webp',
//     link: "https://startupnews.fyi/",
//   },
//   {
//     alt: "privatebanking",
//     src: "/images/privatebanking.webp",
//     link: "https://www.privatebanking.com/",
//   },
//   {
//     alt: "startup-city",
//     src: "/images/startup-city.svg",
//     link: "https://www.startupcity.com/",
//   },
//   {
//     alt: "gaze-international-magazine",
//     src: "/images/gaze-international-magazine.webp",
//     link: "https://gazetinternational.com/",
//   },
//   {
//     alt: "AlHuda-logo",
//     src: "/images/al-huda-logo.webp",
//     link: "https://www.alhudacibe.com/",
//   },
//   {
//     alt: "alhudatoday-logo",
//     src: "/images/alhudatoday-logo.webp",
//     link: "http://www.alhudatoday.com/",
//   },
//   {
//     alt: "wallet-investor",
//     src: "/images/wallet-investor.webp",
//     link: "https://walletinvestor.com/",
//   },

// //   {
// //     alt: "GTM-Labs-Logo-without-BG",
// //     src: "/images/gtm-labs-logo.webp",
// //     link: "https://gtmlabs.xyz/",
// //   },
// //   {
// //     alt: "cryptoJist-black",
// //     src: "/images/cryptoJist-black.webp",
// //     link: "https://cryptojist.com/",
// //   },
// //   {
// //     alt: "allconferencealert",
// //     src: "/images/all-conference-alert.webp",
// //     link: "https://allconferencealert.net/",
// //   },
// //   {
// //     alt: "Coin-Gabbar-forwhite",
// //     src: "/images/coin-gabbar.webp",
// //     link: "https://www.coingabbar.com/",
// //   },
// //   {
// //     alt: "blockchainmedia-logo",
// //     src: "/images/blockchainmedia-logo.webp",
// //     link: "https://blockchainmedia.id/",
// //   },
// //   {
// //     alt: "bitcoininsider-logo-condensed",
// //     src: "/images/bitcoininsider-logo-condensed.webp",
// //     link: "https://bitcoinworld.co.in/",
// //   },
// //   {
// //     alt: "coinscapture",
// //     src: "/images/coinscapture.webp",
// //     link: "https://coinscapture.com/",
// //   },
// //   {
// //     alt: "Cryptopolitan",
// //     src: "/images/cryptopolitan.webp",
// //     width: 170,
// //     height: 140,
// //     link: "https://www.cryptopolitan.com/",
// //   },
// //   {
// //     alt: "AI-Time-Journal",
// //     src: "/images/ai-time-journal.webp",
// //     width: 170,
// //     height: 140,
// //     link: "https://www.aitimejournal.com/",
// //   },
// // {
// //     alt: "coinpedia-fintech-news-blue-logo",
// //     src: "/images/coinpedia-fintech-news-blue-logo.webp",
// //     link: "https://coinpedia.org/",
// //   },
// //   {
// //     alt: "cryptonomist-logo",
// //     src: "/images/cryptonomist-logo.webp",
// //     link: "https://en.cryptonomist.ch/",
// //   },
// //   {
// //     alt: "bitcoin-world-ogo",
// //     src: "/images/bitcoin-world-logo.webp",
// //     link: "https://bitcoinworld.co.in/",
// //   },
// //  {
// //     alt: "cryptoken-media-logo-color",
// //     src: "/images/cryptoken-media-logo-color.webp",
// //     link: "https://cryptoken.media/",
// //   },
// //   {
// //     alt: "Web3Wire-Logo",
// //     src: "/images/web3wire-logo.webp",
// //     link: "https://web3wire.org/",
// //   },
// //   {
// //     alt: "cioreview",
// //     src: "/images/cio-review.webp",
// //     link: "https://www.cioreview.com/",
// //   },
// //   {
// //     alt: "inbm-logo",
// //     src: "/images/inbm-logo.webp",
// //     link: "https://intlbm.com/",
// //   },
// //   {
// //     alt: "edarabia",
// //     src: "/images/edarabia-logo.webp",
// //     link: "https://www.edarabia.com/",
// //   },
// //   {
// //     alt: "gogetgpt",
// //     src: "/images/gogetgpt-logo.svg",
// //     link: "https://gogetgpt.com/",
// //   },
// //   {
// //     alt: "Jinse-Logo-Normal",
// //     src: "/images/Jinse-Logo-Normal.svg",
// //     link: "https://jinse.cn/",
// //   },
// //   {
// //     alt: "AIPressRoom-logo",
// //     src: "/images/ai-pressroom-logo.webp",
// //     link: "http://aipressroom.com/",
// //   },
// //   {
// //     alt: "3versetv",
// //     src: "/images/3versetv.webp",
// //     link: "https://www.3versetv.com/",
// //   },
// //   {
// //     alt: "black-messtori-blockchain",
// //     src: "/images/black-messtori-blockchain.webp",
// //     link: "https://messtori.com/blockchain/",
// //   },
// //   {
// //     alt: "cmo-intern",
// //     src: "/images/cmo-intern.webp",
// //     link: "https://www.cmointern.com/",
// //   },
// //   {
// //     alt: "fintech",
// //     src: "/images/fintech.webp",
// //     link: "https://fintech24h.com/",
// //   },
// //   {
// //     alt: "Golden_sea",
// //     src: "/images/golden-sea.webp",
// //     link: "https://goldenseastudios.com/",
// //   },
// //   {
// //     alt: "AlHuda-logo",
// //     src: "/images/al-huda-logo.webp",
// //     link: "https://www.alhudacibe.com/",
// //   },
// //    {
// //     alt: "times-of-blockchain",
// //     src: "/images/times-of-blockchain.svg",
// //     link: "https://www.timesofblockchain.com/",
// //   },
// //   {
// //     alt: "vitaminai",
// //     src: "/images/vitaminai.webp",
// //     link: "https://vitaminai.online/",
// //   },{
// //     alt: "CryptoNewsZ-Logo",
// //     src: "/images/cryptonewsz-logo.svg",
// //     link: "https://www.cryptonewsz.com/",
// //   },{
// //     alt: "NameCoinNews",
// //     src: "/images/namecoinnews.svg",
// //     link: "https://www.namecoinnews.com/",
// //   },{
// //     alt: "timesofai",
// //     src: "/images/timesofai.svg",
// //     link: "https://www.timesofai.com/",
// //   },{
// //     alt: "Cryptomoonpress",
// //     src: "/images/cryptomoonpress.svg",
// //     link: "https://cryptomoonpress.com/",
// //   },{
// //     alt: "CapitalBayLogo",
// //     src: "/images/capitalbay-news.webp",
// //     link: "https://www.capitalbay.news/",
// //   },
// //   {
// //     alt: "Coinnewsspan",
// //     src: "/images/coinnewsspan-new.svg",
// //     link: "https://www.coinnewsspan.com/",
// //   },
// //   {
// //     alt: "coinaute-logo",
// //     src: "/images/coinaute-logo.webp",
// //     link: "https://coinaute.com/",
// //   },
// //   {
// //     alt: "zexprwire-logo",
// //     src: "/images/zexprwire-logo.webp",
// //     link: "https://zexprwire.com/",
// //   },
// //   {
// //       src: "/images/cryptosnewss.webp",
// //       alt: "CryptosNewss",
// //       link: "https://cryptosnewss.com/",
// //     },
// //     {
// //       src: "/images/coin-edition.webp",
// //       alt: "coin-edition",
// //       link: "https://coinedition.com/",
// //     },
// //     {
// //       src: "/images/ymm-logo.webp",
// //       alt: "ymm-logo",
// //       link: "https://yourmindmedia.com/",
// //     },
// //     {
// //     alt: "TMP-LOGO",
// //     src: "/images/tmp-logo.webp",
// //     width: 170,
// //     height: 140,
// //     link: "https://themarketperiodical.com/",
// //       },
// //       {
// //         alt: "the-coin-republic",
// //         src: "/images/the-coin-republic-logo.webp",
// //         width: 170,
// //         height: 140,
// //         link: "https://www.thecoinrepublic.com/",
// //       },
// //       {
// //         alt: "Financial-service-review",
// //         src: "/images/financial-service-review.webp",
// //         width: 170,
// //         height: 140,
// //         link: "https://www.financialservicesreview.com/",
// //       },
    
// //     {
// //       src: '/images/cryptonews.webp',
// //       alt: 'CryptoNews',
// //       width: 148,
// //       height: 58,
// //       link: 'https://cryptonews.com/',
// //     },

// //     {
// //       src: '/images/affmaven-logo.webp',
// //       alt: 'AFFMaven',
// //       width: 148,
// //       height: 58,
// //       link: 'https://affmaven.com/',
// //     },

// //     {
// //       src: '/images/indewswire-logo.webp',
// //       alt: 'IndNewsWire',
// //       width: 148,
// //       height: 58,
// //       link: 'https://indnewswire.com/',
// //     },
// //     {
// //       src: '/images/droomblack.webp',
// //       alt: 'DroomDroom-Black',
// //       width: 148,
// //       height: 58,
// //       link: 'https://droomdroom.com/',
// //     },

// //     {
// //       src: '/images/web3africa.webp',
// //       alt: 'web3africa',
// //       width: 148,
// //       height: 58,
// //       link: 'https://web3africa.tech/',
// //     },
// //     {
// //       src: '/images/blockchainreporter.webp',
// //       alt: 'blockchainreporter',
// //       width: 148,
// //       height: 58,
// //       link: 'https://blockchainreporter.net/',
// //     },
// //     {
// //       src: '/images/dubai-global-news.webp',
// //       alt: 'dubai-global-news',
// //       width: 148,
// //       height: 58,
// //       link: 'https://www.dubaiglobalnews.com/',
// //     },
// //     {
// //       src: '/images/theblockopedia-new.webp',
// //       alt: 'theblockopedia-new',
// //       width: 148,
// //       height: 58,
// //       link: 'https://theblockopedia.com/',
// //     },
// //     {
// //       src: '/images/startupnews-logo.webp',
// //       alt: 'startupnews-logo',
// //       width: 148,
// //       height: 58,
// //       link: 'https://startupnews.fyi/',
// //     },
//   ];


const partners = [
  {
    alt: "Financial-service-review",
    src: "/images/financial-service-review.webp",
    link: "https://www.financialservicesreview.com/",
  },
  {
    alt: "aiml",
    src: "/images/aiml.webp",
    link: "https://aiml.events/",
  },
  {
    alt: 'startupnews-logo',
    src: '/images/startupnews-logo.webp',
    link: "https://startupnews.fyi/",
  },
  {
    alt: "privatebanking",
    src: "/images/privatebanking.webp",
    link: "https://www.privatebanking.com/",
  },
  {
    alt: "startup-city",
    src: "/images/startup-city.svg",
    link: "https://www.startupcity.com/",
  },
  {
    alt: "gaze-international-magazine",
    src: "/images/gaze-international-magazine.webp",
    link: "https://gazetinternational.com/",
  },
  {
    alt: "AlHuda-logo",
    src: "/images/al-huda-logo.webp",
    link: "https://www.alhudacibe.com/",
  },
  {
    alt: "alhudatoday-logo",
    src: "/images/alhudatoday-logo.webp",
    link: "http://www.alhudatoday.com/",
  },
  {
    alt: "wallet-investor",
    src: "/images/wallet-investor.webp",
    link: "https://walletinvestor.com/",
  },

  // ---- newly added partners ----
  {
    alt: "africa-market-access",
    src: "/images/africa-market-access.webp",
    link: "https://www.africamarketaccess.com/",
  },
  {
    alt: "coingabbar",
    src: "/images/coin-gabbar.webp",
    link: "https://www.coingabbar.com/",
  },
  {
    alt: "coinraftar",
    src: "/images/coinraftar-logo.webp",
    link: "https://coinraftar.com/",
  },
  {
    alt: "etherpr",
    src: "/images/ether-pr.webp",
    link: "https://etherpr.com/",
  },
  {
    alt: "coinrab",
    src: "/images/coinrab.webp",
    link: "https://coinrab.com/",
  },
  {
    alt: "droomdroom",
    src: "/images/droomdroom.webp",
    link: "https://droomdroom.com/",
  },
  {
    alt: "cryptonite-ae",
    src: "/images/cryptonite.webp",
    link: "https://www.cryptonite.ae/",
  },
  {
    alt: "blockchainreporter",
    src: "/images/blockchainreporter.webp",
    link: "https://blockchainreporter.net/",
  },
  {
    alt: "edarabia",
    src: "/images/edarabia-logo.webp",
    link: "https://www.edarabia.com/",
  },
  {
    alt: "bitcoininsider",
    src: "/images/bitcoininsider-logo-condensed.webp",
    link: "https://www.bitcoininsider.org/",
  },
  {
    alt: "theholycoins",
    src: "/images/theholycoins.webp",
    link: "https://theholycoins.com/",
  },
  {
    alt: "coin-edition",
    src: "/images/coin-edition.webp",
    link: "https://coinedition.com/",
  },
  {
    alt: "bdventures",
    src: "/images/bdventures.webp",
    link: "https://www.bdventures.vn/",
  },
  {
    alt: "cryptobrowser",
    src: "/images/cryptobrowser.svg",
    link: "https://cryptobrowser.io/",
  },
  {
    alt: "payrealfi-logo",
    src: "/images/payrealfi-logo.webp",
    link: "https://payrealfi.com/",
  },
  {
    alt: "blockchainmedia-logo-black",
    src: "/images/blockchainmedia-logo-black.webp",
    link: "https://blockchainmedia.id/",
  },
  {
    alt: "embassy-of-bitcoin",
    src: "/images/embassy-of-bitcoin.webp",
    link: "https://www.embassyofbitcoin.com/",
  },
  {
    alt: "cryptosnewss",
    src: "/images/cryptosnewss.webp",
    link: "https://cryptosnewss.com/",
  },
  {
    alt: "coingape",
    src: "/images/coingape.webp",
    link: "https://coingape.com/",
  },
  {
    alt: "forkoff",
    src: "/images/forkoff.webp",
    link: "https://forkoff.xyz/",
  },
  {
    alt: "icoholder",
    src: "/images/icoholder.webp",
    link: "https://icoholder.com/",
  },
  {
    alt: "the-times-of-uae",
    src: "/images/the-times-of-uae.webp",
    link: "https://thetimesofuae.com/",
  },
  {
    alt: "Jinse-Logo-Normal",
    src: "/images/Jinse-Logo-Normal.svg",
    link: "https://jinse.cn/",
  },
  {
    alt: "toktimes",
    src: "/images/toktimes.webp",
    link: "https://toktimes.com/",
  },
  {
    alt: "chaindecrypt",
    src: "/images/chaindecrypt.webp",
    link: "https://chaindecrypt.com/",
  },
  {
    alt: "forex-penguin",
    src: "/images/forex-penguin.webp",
    link: "https://www.forexpenguin.com/",
  },
  {
    alt: "crypto-times",
    src: "/images/cryptotimes.svg",
    link: "https://www.cryptotimes.io/",
  },
  {
    alt: "coinstori",
    src: "/images/coinstoriblack.webp",
    link: "https://coinstori.com/",
  },
  {
    alt: "voice-of-crypto",
    src: "/images/voiceofcrypto.webp",
    link: "https://voiceofcrypto.online/",
  },
  {
    alt: "coinfea",
    src: "/images/coinfea.webp",
    link: "https://coinfea.com/",
  },
  {
    alt: "Cryptopolitan",
    src: "/images/cryptopolitan.webp",
    width: 170,
    height: 140,
    link: "https://www.cryptopolitan.com/",
  },
  {
    alt: "bitcoin-world-logo",
    src: "/images/bitcoin-world-logo.webp",
    link: "https://bitcoinworld.co.in/",
  },
  {
    alt: "coincodex",
    src: "/images/coincodex.webp",
    link: "https://coincodex.com/",
  },
  {
    alt: "coincarp",
    src: "/images/coincarp.webp",
    link: "https://www.coincarp.com/",
  },
  {
    alt: "coincheckup",
    src: "/images/coincheckup.webp",
    link: "https://coincheckup.com/",
  },
  {
    alt: "coinpaper",
    src: "/images/coinpaper.webp",
    link: "https://coinpaper.com/",
  },
  {
    alt: "coinscapture",
    src: "/images/coinscapture.webp",
    link: "https://coinscapture.com/",
  },
  {
    alt: "cryptonomist-logo",
    src: "/images/cryptonomist-logo.webp",
    link: "https://en.cryptonomist.ch/",
  },
  {
    alt: "block24seven",
    src: "/images/block24seven.webp",
    link: "https://block24seven.com/",
  },
  {
    alt: "zexprwire-logo",
    src: "/images/zexprwire-logo.webp",
    link: "https://zexprwire.com/",
  },

//   {
//     alt: "GTM-Labs-Logo-without-BG",
//     src: "/images/gtm-labs-logo.webp",
//     link: "https://gtmlabs.xyz/",
//   },
//   {
//     alt: "cryptoJist-black",
//     src: "/images/cryptoJist-black.webp",
//     link: "https://cryptojist.com/",
//   },
//   {
//     alt: "allconferencealert",
//     src: "/images/all-conference-alert.webp",
//     link: "https://allconferencealert.net/",
//   },
//   {
//     alt: "Coin-Gabbar-forwhite",
//     src: "/images/coin-gabbar.webp",
//     link: "https://www.coingabbar.com/",
//   },
//   {
//     alt: "blockchainmedia-logo",
//     src: "/images/blockchainmedia-logo.webp",
//     link: "https://blockchainmedia.id/",
//   },
//   {
//     alt: "bitcoininsider-logo-condensed",
//     src: "/images/bitcoininsider-logo-condensed.webp",
//     link: "https://bitcoinworld.co.in/",
//   },
//   {
//     alt: "coinscapture",
//     src: "/images/coinscapture.webp",
//     link: "https://coinscapture.com/",
//   },
//   {
//     alt: "Cryptopolitan",
//     src: "/images/cryptopolitan.webp",
//     width: 170,
//     height: 140,
//     link: "https://www.cryptopolitan.com/",
//   },
//   {
//     alt: "AI-Time-Journal",
//     src: "/images/ai-time-journal.webp",
//     width: 170,
//     height: 140,
//     link: "https://www.aitimejournal.com/",
//   },
// {
//     alt: "coinpedia-fintech-news-blue-logo",
//     src: "/images/coinpedia-fintech-news-blue-logo.webp",
//     link: "https://coinpedia.org/",
//   },
//   {
//     alt: "cryptonomist-logo",
//     src: "/images/cryptonomist-logo.webp",
//     link: "https://en.cryptonomist.ch/",
//   },
//   {
//     alt: "bitcoin-world-ogo",
//     src: "/images/bitcoin-world-logo.webp",
//     link: "https://bitcoinworld.co.in/",
//   },
//  {
//     alt: "cryptoken-media-logo-color",
//     src: "/images/cryptoken-media-logo-color.webp",
//     link: "https://cryptoken.media/",
//   },
//   {
//     alt: "Web3Wire-Logo",
//     src: "/images/web3wire-logo.webp",
//     link: "https://web3wire.org/",
//   },
//   {
//     alt: "cioreview",
//     src: "/images/cio-review.webp",
//     link: "https://www.cioreview.com/",
//   },
//   {
//     alt: "inbm-logo",
//     src: "/images/inbm-logo.webp",
//     link: "https://intlbm.com/",
//   },
//   {
//     alt: "edarabia",
//     src: "/images/edarabia-logo.webp",
//     link: "https://www.edarabia.com/",
//   },
//   {
//     alt: "gogetgpt",
//     src: "/images/gogetgpt-logo.svg",
//     link: "https://gogetgpt.com/",
//   },
//   {
//     alt: "Jinse-Logo-Normal",
//     src: "/images/Jinse-Logo-Normal.svg",
//     link: "https://jinse.cn/",
//   },
//   {
//     alt: "AIPressRoom-logo",
//     src: "/images/ai-pressroom-logo.webp",
//     link: "http://aipressroom.com/",
//   },
//   {
//     alt: "3versetv",
//     src: "/images/3versetv.webp",
//     link: "https://www.3versetv.com/",
//   },
//   {
//     alt: "black-messtori-blockchain",
//     src: "/images/black-messtori-blockchain.webp",
//     link: "https://messtori.com/blockchain/",
//   },
//   {
//     alt: "cmo-intern",
//     src: "/images/cmo-intern.webp",
//     link: "https://www.cmointern.com/",
//   },
//   {
//     alt: "fintech",
//     src: "/images/fintech.webp",
//     link: "https://fintech24h.com/",
//   },
//   {
//     alt: "Golden_sea",
//     src: "/images/golden-sea.webp",
//     link: "https://goldenseastudios.com/",
//   },
//   {
//     alt: "AlHuda-logo",
//     src: "/images/al-huda-logo.webp",
//     link: "https://www.alhudacibe.com/",
//   },
//    {
//     alt: "times-of-blockchain",
//     src: "/images/times-of-blockchain.svg",
//     link: "https://www.timesofblockchain.com/",
//   },
//   {
//     alt: "vitaminai",
//     src: "/images/vitaminai.webp",
//     link: "https://vitaminai.online/",
//   },{
//     alt: "CryptoNewsZ-Logo",
//     src: "/images/cryptonewsz-logo.svg",
//     link: "https://www.cryptonewsz.com/",
//   },{
//     alt: "NameCoinNews",
//     src: "/images/namecoinnews.svg",
//     link: "https://www.namecoinnews.com/",
//   },{
//     alt: "timesofai",
//     src: "/images/timesofai.svg",
//     link: "https://www.timesofai.com/",
//   },{
//     alt: "Cryptomoonpress",
//     src: "/images/cryptomoonpress.svg",
//     link: "https://cryptomoonpress.com/",
//   },{
//     alt: "CapitalBayLogo",
//     src: "/images/capitalbay-news.webp",
//     link: "https://www.capitalbay.news/",
//   },
//   {
//     alt: "Coinnewsspan",
//     src: "/images/coinnewsspan-new.svg",
//     link: "https://www.coinnewsspan.com/",
//   },
//   {
//     alt: "coinaute-logo",
//     src: "/images/coinaute-logo.webp",
//     link: "https://coinaute.com/",
//   },
//   
//   {
//       src: "/images/cryptosnewss.webp",
//       alt: "CryptosNewss",
//       link: "https://cryptosnewss.com/",
//     },
//     {
//       src: "/images/coin-edition.webp",
//       alt: "coin-edition",
//       link: "https://coinedition.com/",
//     },
//     {
//       src: "/images/ymm-logo.webp",
//       alt: "ymm-logo",
//       link: "https://yourmindmedia.com/",
//     },
//     {
//     alt: "TMP-LOGO",
//     src: "/images/tmp-logo.webp",
//     width: 170,
//     height: 140,
//     link: "https://themarketperiodical.com/",
//       },
//       {
//         alt: "the-coin-republic",
//         src: "/images/the-coin-republic-logo.webp",
//         width: 170,
//         height: 140,
//         link: "https://www.thecoinrepublic.com/",
//       },
//       {
//         alt: "Financial-service-review",
//         src: "/images/financial-service-review.webp",
//         width: 170,
//         height: 140,
//         link: "https://www.financialservicesreview.com/",
//       },
    
//     {
//       src: '/images/cryptonews.webp',
//       alt: 'CryptoNews',
//       width: 148,
//       height: 58,
//       link: 'https://cryptonews.com/',
//     },

//     {
//       src: '/images/affmaven-logo.webp',
//       alt: 'AFFMaven',
//       width: 148,
//       height: 58,
//       link: 'https://affmaven.com/',
//     },

//     {
//       src: '/images/indewswire-logo.webp',
//       alt: 'IndNewsWire',
//       width: 148,
//       height: 58,
//       link: 'https://indnewswire.com/',
//     },
//     {
//       src: '/images/droomblack.webp',
//       alt: 'DroomDroom-Black',
//       width: 148,
//       height: 58,
//       link: 'https://droomdroom.com/',
//     },

//     {
//       src: '/images/web3africa.webp',
//       alt: 'web3africa',
//       width: 148,
//       height: 58,
//       link: 'https://web3africa.tech/',
//     },
//     {
//       src: '/images/blockchainreporter.webp',
//       alt: 'blockchainreporter',
//       width: 148,
//       height: 58,
//       link: 'https://blockchainreporter.net/',
//     },
//     {
//       src: '/images/dubai-global-news.webp',
//       alt: 'dubai-global-news',
//       width: 148,
//       height: 58,
//       link: 'https://www.dubaiglobalnews.com/',
//     },
//     {
//       src: '/images/theblockopedia-new.webp',
//       alt: 'theblockopedia-new',
//       width: 148,
//       height: 58,
//       link: 'https://theblockopedia.com/',
//     },
//     {
//       src: '/images/startupnews-logo.webp',
//       alt: 'startupnews-logo',
//       width: 148,
//       height: 58,
//       link: 'https://startupnews.fyi/',
//     },
  ];



const PartnersSection = () => {
  return (
    <section data-component-id="src/app/mediaPartnerSection.tsx:872:4" data-component-path="src/app/mediaPartnerSection.tsx" data-component-line="872" data-component-file="mediaPartnerSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22partners%22%2C%22className%22%3A%22w-full%20mx-auto%20px-4%20flex%20flex-col%20items-center%20justify-center%20bg-%5Blinear-gradient(360deg%2C%23060606_0%25%2C%23000000_70%25%2C_%23120049_100%25)%5D%20sm%3Apt-%5B80px%5D%20sm%3Apb-%5B80px%5D%20py-%5B40px%5D%22%7D"
      id="partners"
      className="w-full mx-auto px-4 flex flex-col items-center justify-center bg-[linear-gradient(360deg,#060606_0%,#000000_70%,_#120049_100%)] sm:pt-[80px] sm:pb-[80px] py-[40px]"
    >
      <div data-component-id="src/app/mediaPartnerSection.tsx:876:6" data-component-path="src/app/mediaPartnerSection.tsx" data-component-line="876" data-component-file="mediaPartnerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1270px%5D%22%7D" className="w-full max-w-[1270px]">
        {/* Section Title */}
        <h2 data-component-id="src/app/mediaPartnerSection.tsx:878:8" data-component-path="src/app/mediaPartnerSection.tsx" data-component-line="878" data-component-file="mediaPartnerSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22uppercase%20text-2xl%20sm%3Atext-3xl%20md%3Atext-4xl%20lg%3Atext-%5B28px%5D%20font-open-sans%20font-semibold%20leading-8%20sm%3Aleading-9%20md%3Aleading-10%20lg%3Aleading-%5B39px%5D%20text-center%20text-white%20pb-%5B30px%5D%22%2C%22textContent%22%3A%22Media%20Partners%22%7D" className="uppercase text-2xl sm:text-3xl md:text-4xl lg:text-[28px] font-open-sans font-semibold leading-8 sm:leading-9 md:leading-10 lg:leading-[39px] text-center text-white pb-[30px]">
          Media Partners
        </h2>

        {/* Partner Logos Box */}
        <div data-component-id="src/app/mediaPartnerSection.tsx:883:8" data-component-path="src/app/mediaPartnerSection.tsx" data-component-line="883" data-component-file="mediaPartnerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%22%7D" className="w-full">
          <div data-component-id="src/app/mediaPartnerSection.tsx:884:10" data-component-path="src/app/mediaPartnerSection.tsx" data-component-line="884" data-component-file="mediaPartnerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-3%20lg%3Agrid-cols-6%20gap-4%20place-items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 place-items-center">
            {partners.map((partner, index) => (
              <a data-component-id="src/app/mediaPartnerSection.tsx:886:14" data-component-path="src/app/mediaPartnerSection.tsx" data-component-line="886" data-component-file="mediaPartnerSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22bg-%5B%23f3f4f6%5D%20rounded-lg%20flex%20items-center%20justify-center%20w-full%20h-%5B60px%5D%20p-4%20hover%3Ashadow-md%20transition-all%22%7D" key={index} href={partner.link} target="_blank"  
              rel={
              partner.link === "https://www.cryptonewsz.com/"
                ? "noopener noreferrer"
                : "noopener noreferrer nofollow"
            }
              className="bg-[#f3f4f6] rounded-lg flex items-center justify-center w-full h-[60px] p-4 hover:shadow-md transition-all"
              >
                <Image data-component-id="src/app/mediaPartnerSection.tsx:894:16" data-component-path="src/app/mediaPartnerSection.tsx" data-component-line="894" data-component-file="mediaPartnerSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20h-%5B60px%5D%20py-2%20transition-transform%20duration-200%20hover%3Ascale-105%22%7D"
                  src={partner.src}
                  alt={partner.alt}
                  width={170}
                  height={80}
                  unoptimized
                  className="object-contain h-[60px] py-2 transition-transform duration-200 hover:scale-105"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
